import PopoverMUI from '@material-ui/core/Popover';
import { createStyles, withStyles } from '@material-ui/styles';
import { transition } from '@topconagriculture/theme';
import classNames from 'classnames';
import * as React from 'react';
import { compose, defaultProps, pure, withState } from 'recompose';
const positions = {
    bottomRight: {
        anchorOriginVertical: 'bottom',
        anchorOriginHorizontal: 'right',
        transformOriginVertical: 'top',
        transformOriginHorizontal: 'right',
    },
    bottomCenter: {
        anchorOriginVertical: 'bottom',
        anchorOriginHorizontal: 'center',
        transformOriginVertical: 'top',
        transformOriginHorizontal: 'center',
    },
};
const styles = (theme) => createStyles({
    rootContainer: {
        position: 'relative',
    },
    popoverArrow: {
        transition: transition(200, 'opacity', 'ease-in-out'),
        opacity: 0,
        position: 'absolute',
        height: 0,
        width: 0,
        borderWidth: 7,
        bottom: -8,
        left: 'calc(50% - 7px)',
        borderColor: 'transparent',
        borderBottomColor: theme.color.background.light,
        borderStyle: 'solid',
        '&.show': {
            opacity: 1,
        },
    },
    expandableContainer: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: theme.common.borderRadius.default,
        opacity: 0.95,
    },
    popoverPaper: {
        marginTop: 8,
    },
});
const renderChild = (child, props) => (React.isValidElement(child) ? React.cloneElement(child, { ...props }) : child);
const injectChildrenProps = (children, props) => React.Children.map(children, (child) => renderChild(child, { closePopover: () => props.setOpen(false) }));
const Popover = (props) => {
    const { anchorEl, autoCloseOnClick, children, classes, clickableComponent, controlled, disableRestoreFocus, open, popoverArrow, position, setAnchorEl, setOpen, testId = 'Popover', } = props;
    const currentPosition = positions[position] || positions.bottomRight;
    const anchorOrigin = {
        horizontal: currentPosition.anchorOriginHorizontal,
        vertical: currentPosition.anchorOriginVertical,
    };
    const transformOrigin = {
        horizontal: currentPosition.transformOriginHorizontal,
        vertical: currentPosition.transformOriginVertical,
    };
    const popoverArrowClass = classNames({
        [classes.popoverArrow]: true,
        show: open,
    });
    return (React.createElement("div", { ref: setAnchorEl, className: classes.rootContainer, "data-testid": `${testId}-container` },
        clickableComponent({ setOpen, open }),
        popoverArrow && React.createElement("div", { className: popoverArrowClass }),
        React.createElement(PopoverMUI, { "data-testid": `${testId}`, anchorEl: anchorEl, anchorOrigin: anchorOrigin, classes: { paper: classes.popoverPaper }, disableRestoreFocus: disableRestoreFocus, onClose: () => setOpen(!open), open: open, transformOrigin: transformOrigin },
            React.createElement("div", { "data-testid": `${testId}-close`, onClick: () => autoCloseOnClick && setOpen(false), className: classes.expandableContainer }, controlled ? injectChildrenProps(children, props) : children))));
};
const ComposedPopover = compose(withStyles(styles, { withTheme: true }), pure, defaultProps({
    popoverArrow: false,
    autoCloseOnClick: false,
}), withState('open', 'setOpen', false), withState('anchorEl', 'setAnchorEl', null))(Popover);
ComposedPopover.displayName = 'Popover';
export default ComposedPopover;
//# sourceMappingURL=Popover.js.map